import brandTheme from '../../Assets/Styles/brandTheme'

const {
  colors: { primary },
} = brandTheme()

export const styles = {
  root: {
    position: 'fixed',
    bottom: 20,
    right: 20,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonShape: {
    height: 60,
    width: 60,
    background: primary,
    cursor: 'pointer',
    color: '#FFFFFF',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.10)',
    border: '1px solid #E2E2FC',
  },
  chatAssistantShape: {
    height: 42,
    width: 42,
    background: 'white',
    cursor: 'pointer',
    color: '#FFFFFF',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    selfAlign: 'flex-start',
    boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.10)',
    border: '1px solid #E2E2FC',
  },
  closeWrapper: {
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    height: 180,
    width: 250,
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
  textButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 15,
    marginRight: 10,
  },
  darkScreen: {
    background: 'rgba(0, 0, 0, 0.5)',
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: 0,
    left: 0,
  },
  helpAssistantText: {
    color: 'white',
    fontWeight: 700,
    fontSize: 16,
  },
}
